export enum StorefrontCustomerProfilesWorkspaceCapabilityAccessOperation {
    create = "c61f9dca-e0a9-4d26-9977-38a49ed1871f",
    read = "c77e3d96-4132-4d39-a3fe-3e49ec1ba666",
    update = "7f62880c-12e4-41ac-8961-c949b99c6430",
    delete = "9d0ec8cf-a7d5-432e-b799-1a4ef315a7d4",
}
